

























import { defineComponent, PropType } from '@vue/composition-api';
import { AssetType, AssetItem, AssetName } from '@tt4b/ttam-enums';

export default defineComponent({
  name: 'TtamCreativeAssetBalanceContent',
  props: {
    assetData: {
      type: Array as PropType<AssetItem[]>,
      default: (): AssetItem[] => [
        {
          assetName: 'Pixel ID',
          assetType: AssetType.Pixel,
          assetId: '7039758440029275906',
        },
        {
          assetName: 'Catalog ID',
          assetType: AssetType.Catalog,
          assetId: '7039758440029275907',
        },
        {
          assetName: 'module_creative_tiktok_account',
          assetType: AssetType.Identity,
          assetId: '7039758440029275908',
        },
      ],
    },
  },
  setup() {
    return { AssetName };
  },
});
